const activeControllers = new Map<string, AbortController>();

export const getAbortSignalForKey = (key: string) => {
  // cancel previous request if exists
  const existingController = activeControllers.get(key);
  if (existingController) {
    existingController.abort();
  }
  const controller = new AbortController();
  activeControllers.set(key, controller);
  return controller.signal;
};

export const clearAbortController = (key: string) => {
  activeControllers.delete(key);
};
